import { Link, useLocation, useNavigate, Navigate } from 'react-router-dom'
import {States} from '../data/States'
import axios from "axios";
import { useState, useEffect } from 'react';
import Footer from '../shared/Footer';
import {updateGolferProfile} from '../API/APICalls';

export default function AddressForm() {

    const navigate = useNavigate();
    const location = useLocation();

   
    let zipsearch = location.state.zipcode;
    let agadata = location?.state.aga;
    let golferdata = location?.state?.inputs;

    const[userdata, setUserdata] = useState();
    const [isLoading, setIsLoading] = useState(true);


    const [inputs, setInputs] = useState({firstname: golferdata.firstname, lastname: golferdata.lastname, phone: golferdata.phone, email: golferdata.email, dob: golferdata.dob, sex: golferdata.sex, address: golferdata.address || '', address2: golferdata.address2 || '', city:golferdata.city || '', state:agadata[0].state, zip: agadata[0].zipcode, contact: golferdata.contact || golferdata.contact_guid || '', handicapID: golferdata.handicapID || ''});
   
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) =>  setInputs(inputs => ({ ...inputs, [name]: value }));

    

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        
       
      const response= await updateGolferProfile(agadata, inputs, location.pathname);

       

        
        navigate('/payment', {replace:true, state:{zipcode:zipsearch, aga:agadata, inputs:inputs}});
    
  
      }


      useEffect(() => {

      
       
        setIsLoading(false);
        document.title = 'Get a Handicap - Address Information';
        
      // setInputs(golferdata);
    }, [location.pathname]);




    return(
        <>
        <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Address</h1></div>
            
          <div className="col-12">
            <form onSubmit={handleSubmit} autoComplete='off'>    

                  {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}       

           <div className="col-sm-12 col-12 col-md-12 col-lg-12 col-xl-12">  

            <div className="col-12">
                        <label className="form-label">Street Address*</label>
                        <input type="text" className="form-control" id="address" name="address" placeholder="" autoFocus value={inputs.address || ''} pattern="^[a-zA-Z\/'\.\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$" onChange={handleChange} maxLength={46} required/>
                    </div>

                    <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-12 mt-2">
                        <label className="form-label">Address 2</label>
                        <input type="text" className="form-control" id="address2" name="address2" placeholder="" value={inputs.address2 || ''} onChange={handleChange} pattern="^[a-zA-Z\/'\.\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$"/>  
                    </div>

                    <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-12 mt-2">
                        <label className="form-label">City*</label>
                        <input type="text" className="form-control" id="city" name="city" value={inputs.city || ''} onChange={handleChange} pattern="^[a-zA-Z\/'\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$" required/>
                        
                    </div>
                    
                    <div className='col-12'>
                            <div className='row'>
                                <div className="col-sm-6 col-sm-6 col-6 col-md-6 col-lg-6 mt-2">
                                    <label className="form-label">State</label>
                                    <select name="state" className="form-select" id="state" onChange={handleChange} value={inputs.state} disabled>             
                                            <option value="">Please select state</option>
                                            {States.map((option, index) =>(
                                            <option value={option.value} key={index}>{option.label}</option>
                                            ))}
                                        </select>                        
                                </div>

                                <div className="col-sm-6 col-6 col-md-6 col-lg-6 mt-2">
                                        <label className="form-label">ZIP Code</label>
                                        <input type="text" className="form-control" id="zipcode" placeholder="" name="zip" value={inputs.zip || ''} onChange={handleChange} disabled/>
                                        
                                    </div>
                                </div>
                    
                    </div>
                    
                        <div className="mt-4 col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12">
                            <div className='row'>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-1 pt-3">
                                <Link replace={true} to="/personal-info" state={{zipcode:zipsearch, aga:agadata, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill" type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-sm-1 order-lg-1 pt-3">
                                <button className="btn btn-primary w-100 btn-lg rounded-pill" type="submit">
                                    CONTINUE
                                </button>
                            </div>
                        </div>
                        </div>
                        </div>
                        <div className="row text-center"><p className="pt-4">If you're having trouble, contact the <a href='mailto:gcsupport@usga.org' target="blank">USGA</a>.</p></div>
                        </form>
                        </div>
                
   </div>
   
  </div>
  <footer />
  </>
    )
}